import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { SpaceProfile } from 'APP/main/Profile/SpaceProfile/SpaceProfile';

import {
  ISpaceProfilePopupParams,
  useSpaceProfilePopupPresenter,
} from './SpaceProfilePopup.presenter';
import styles from './SpaceProfilePopup.styles.m.css';

export const SpaceProfilePopup: FC<ICommonPopupsProps<ISpaceProfilePopupParams>> = observer(
  (props: ICommonPopupsProps<ISpaceProfilePopupParams>) => {
    const presenter = useSpaceProfilePopupPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        isOpened={!!presenter.space}
        isHidden={props.popupInstance.isHidden}
        onClose={presenter.onClose}
      >
        {presenter.space && (
          <SpaceProfile
            className={styles.profile}
            metaBlockClassName={styles.profileMetaBlock}
            space={presenter.space}
            popupInstance={props.popupInstance}
            onClose={presenter.onClose}
          />
        )}
      </Popup>
    );
  }
);
